import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Globe, TrendingUp } from 'lucide-react';
import NewsletterModal from '../UI/NewsletterModal';

const categories = [
  { name: 'Geopolitics', icon: '🌍' },
  { name: 'Economy', icon: '💰' },
  { name: 'Climate', icon: '🌱' },
  { name: 'Health', icon: '🧬' },
  { name: 'Technology', icon: '🤖' },
  { name: 'Disasters', icon: '🚨' },
  { name: 'Migration', icon: '👥' }
];

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isNewsletterOpen, setIsNewsletterOpen] = useState(false);

  return (
    <>
      <header className="bg-white border-b-2 border-primary-900">
        {/* Top Bar */}
        <div className="bg-primary-900 text-white py-2">
          <div className="container-news">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center space-x-4">
                <span className="flex items-center">
                  <Globe className="h-4 w-4 mr-1" />
                  Global Impact News
                </span>
                <span className="hidden md:block">
                  Updated {new Date().toLocaleDateString()}
                </span>
              </div>
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => setIsNewsletterOpen(true)}
                  className="hover:text-accent-400 transition-colors"
                >
                  Subscribe
                </button>
                <span className="flex items-center">
                  <TrendingUp className="h-4 w-4 mr-1" />
                  Zero Noise
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Header */}
        <div className="container-news py-6">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex flex-col">
              <h1 className="font-playfair text-4xl font-black text-primary-900 tracking-tight">
                UNBIASED NEWS
              </h1>
              <p className="font-inter text-sm text-primary-600 tracking-widest uppercase">
                Structural Impact, Zero Noise
              </p>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="nav-link">
                Latest
              </Link>
              {categories.map((category) => (
                <Link
                  key={category.name}
                  to={`/category/${encodeURIComponent(category.name)}`}
                  className="nav-link flex items-center"
                >
                  <span className="mr-1">{category.icon}</span>
                  {category.name}
                </Link>
              ))}
              <Link to="/admin" className="nav-link">
                Admin
              </Link>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6 text-primary-900" />
              ) : (
                <Menu className="h-6 w-6 text-primary-900" />
              )}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="lg:hidden mt-6 pt-6 border-t border-primary-200">
              <div className="flex flex-col space-y-4">
                <Link 
                  to="/" 
                  className="nav-link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Latest
                </Link>
                {categories.map((category) => (
                  <Link
                    key={category.name}
                    to={`/category/${encodeURIComponent(category.name)}`}
                    className="nav-link flex items-center"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <span className="mr-2">{category.icon}</span>
                    {category.name}
                  </Link>
                ))}
                <Link 
                  to="/admin" 
                  className="nav-link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Admin
                </Link>
              </div>
            </nav>
          )}
        </div>

        {/* Category Strip */}
        <div className="hidden md:block bg-primary-50 border-t border-primary-200">
          <div className="container-news py-3">
            <div className="flex items-center justify-center space-x-6">
              {categories.map((category) => (
                <Link
                  key={category.name}
                  to={`/category/${encodeURIComponent(category.name)}`}
                  className="flex items-center text-sm text-primary-700 hover:text-accent-600 transition-colors"
                >
                  <span className="mr-1">{category.icon}</span>
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </header>

      {/* Newsletter Modal */}
      <NewsletterModal 
        isOpen={isNewsletterOpen} 
        onClose={() => setIsNewsletterOpen(false)} 
      />
    </>
  );
};

export default Header;